<mat-card class="card-style-full px-6 py-6 pt-0">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Visualizar Monitoramento</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  <div class="mt-4 mb-2"></div>
  <mat-card class="card-style px-6 pb-6">

    <div class="flex justify-end mt-3">

      <button
        mat-flat-button
        class="btn-tg w-1/5 finalizar-btn"
        [disabled]="!checkForm() || loading"
        (click)="editDriver()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          <span class="btn-content">
      Finalizar
    </span>
        }
      </button>
    </div>

  </mat-card>
</mat-card>
